import { observer } from "mobx-react-lite";
import { usePopupStore } from "../..";
import useNavigateToTenantInMarket from "../../hooks/useNavigateToTenantInMarket";
import ITenantInMarket from "../../interfaces/ITenantInMarket";
import PopupType from "../../interfaces/PopupType";
import { formatNumber, formatPrice } from "../../utils/utils";
import commonStyles from "../Common.module.css";
import Grid from "../Grid";

function TenantsInMarketGrid({ tenantsInMarket }: ITenantsInMarketGridProps) {
    const popupStore = usePopupStore();
    const navigateToTenantInMarket = useNavigateToTenantInMarket();

    return (
        <Grid
            data={tenantsInMarket}
            headers={[
                {
                    align: "left",
                    titleStrings: ["DESCRIPTION"],
                    getValue: item => item.description,
                    getLabel: item => item.description || "",
                },
                {
                    titleStrings: ["LAND AREA NEEDED"],
                    getValue: item => item.landAreaMin,
                    getLabel: item => item.landAreaMin && item.landAreaMax ? `${formatNumber(item.landAreaMin)} - ${formatNumber(item.landAreaMax)} Acres` : "",
                },
                {
                    titleStrings: ["BUILDING AREA NEEDED"],
                    getValue: item => item.buildingAreaMin,
                    getLabel: item => item.buildingAreaMin && item.buildingAreaMax ? `${formatNumber(item.buildingAreaMin)} - ${formatNumber(item.buildingAreaMax)} Sq-Ft` : "",
                },
                {
                    titleStrings: ["USE TYPE"],
                    getValue: item => item.useType,
                    getLabel: item => item.useType || "",
                },
                {
                    titleStrings: ["ZONING"],
                    getValue: item => item.zoningRequired,
                    getLabel: item => item.zoningRequired || "",
                },
                {
                    titleStrings: ["TARGET ANNUAL RENT"],
                    getValue: item => item.targetAnnualRent,
                    getLabel: item => item.targetAnnualRent ? formatPrice(item.targetAnnualRent) : "",
                },
                {
                    titleStrings: ["TIMING"],
                    getValue: item => item.timing,
                    getLabel: item => item.timing || "",
                },
            ]}
            getId={item => item.id}
            downloadFileName={"Tenants in Market"}
            onRowClick={item => navigateToTenantInMarket(item.id)}
            isRowActive={item => popupStore.type === PopupType.TenantInMarket && popupStore.id === item.id}
            header={<div className={[commonStyles.gridTitle, commonStyles.header].join(" ")}>{tenantsInMarket.length} Tenants in Market</div>}
        />
    );
}

export default observer(TenantsInMarketGrid);

interface ITenantsInMarketGridProps {
    tenantsInMarket: ITenantInMarket[];
}